var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":_vm.id}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.sections),function(section){return _c(("section-" + section),{key:section,tag:"component"})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }